/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as JudicialRouteImport } from './routes/judicial'
import { Route as IndexRouteImport } from './routes/index'
import { Route as StatsIndexRouteImport } from './routes/stats.index'
import { Route as SoutienIndexRouteImport } from './routes/soutien.index'
import { Route as RegionsIndexRouteImport } from './routes/regions.index'
import { Route as PromotionsIndexRouteImport } from './routes/promotions.index'
import { Route as JudicialIndexRouteImport } from './routes/judicial.index'
import { Route as DashboardIndexRouteImport } from './routes/dashboard.index'
import { Route as AssignmentsIndexRouteImport } from './routes/assignments.index'
import { Route as SoutienPanneauRouteImport } from './routes/soutien.panneau'
import { Route as JudicialRecordIdRouteImport } from './routes/judicial.$recordId'
import { Route as DashboardRegionIdRouteImport } from './routes/dashboard.$regionId'
import { Route as AssignmentsAssignmentIdRouteImport } from './routes/assignments.$assignmentId'
import { Route as PromotionsInitiativeIdIndexRouteImport } from './routes/promotions.$initiativeId.index'
import { Route as JudicialRecordIdIndexRouteImport } from './routes/judicial.$recordId.index'
import { Route as DashboardRegionIdIndexRouteImport } from './routes/dashboard.$regionId.index'
import { Route as PromotionsInitiativeIdPlacementsRouteImport } from './routes/promotions.$initiativeId.placements'
import { Route as PromotionsInitiativeIdNationalRouteImport } from './routes/promotions.$initiativeId.national'
import { Route as PromotionsInitiativeIdRegionIdRouteImport } from './routes/promotions.$initiativeId.$regionId'
import { Route as RegionsMessagesEveningIdIndexRouteImport } from './routes/regions.messages.$eveningId.index'
import { Route as PromotionsInitiativeIdNationalIndexRouteImport } from './routes/promotions.$initiativeId.national.index'
import { Route as PromotionsInitiativeIdRegionIdIndexRouteImport } from './routes/promotions.$initiativeId.$regionId.index'
import { Route as DashboardRegionIdMessagesIndexRouteImport } from './routes/dashboard.$regionId.messages.index'
import { Route as RegionsMessagesEveningIdTeamIdRouteImport } from './routes/regions.messages.$eveningId.$teamId'
import { Route as PromotionsInitiativeIdNationalPromotionIdRouteImport } from './routes/promotions.$initiativeId.national.$promotionId'
import { Route as PromotionsInitiativeIdRegionIdCreateRouteImport } from './routes/promotions.$initiativeId.$regionId.create'
import { Route as PromotionsInitiativeIdRegionIdBoutiqueRouteImport } from './routes/promotions.$initiativeId.$regionId.boutique'
import { Route as PromotionsInitiativeIdRegionIdPromotionIdRouteImport } from './routes/promotions.$initiativeId.$regionId.$promotionId'
import { Route as JudicialRecordIdProvincialSoquijIdRouteImport } from './routes/judicial.$recordId.provincial.$soquijId'
import { Route as JudicialRecordIdMunicipalSoquijIdRouteImport } from './routes/judicial.$recordId.municipal.$soquijId'
import { Route as DashboardRegionIdMessagesNoneRouteImport } from './routes/dashboard.$regionId.messages.none'
import { Route as DashboardRegionIdMessagesTeamIdRouteImport } from './routes/dashboard.$regionId.messages.$teamId'
import { Route as PromotionsInitiativeIdNationalCreateIndexRouteImport } from './routes/promotions.$initiativeId.national.create.index'
import { Route as RegionsMessagesEveningIdChannelsChannelIdRouteImport } from './routes/regions.messages.$eveningId.channels.$channelId'
import { Route as PromotionsInitiativeIdNationalCreateTypeRouteImport } from './routes/promotions.$initiativeId.national.create.$type'
import { Route as DashboardRegionIdMessagesChannelsChannelIdRouteImport } from './routes/dashboard.$regionId.messages.channels.$channelId'

const JudicialRoute = JudicialRouteImport.update({
  id: '/judicial',
  path: '/judicial',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const StatsIndexRoute = StatsIndexRouteImport.update({
  id: '/stats/',
  path: '/stats/',
  getParentRoute: () => rootRouteImport,
} as any)
const SoutienIndexRoute = SoutienIndexRouteImport.update({
  id: '/soutien/',
  path: '/soutien/',
  getParentRoute: () => rootRouteImport,
} as any)
const RegionsIndexRoute = RegionsIndexRouteImport.update({
  id: '/regions/',
  path: '/regions/',
  getParentRoute: () => rootRouteImport,
} as any)
const PromotionsIndexRoute = PromotionsIndexRouteImport.update({
  id: '/promotions/',
  path: '/promotions/',
  getParentRoute: () => rootRouteImport,
} as any)
const JudicialIndexRoute = JudicialIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => JudicialRoute,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/dashboard/',
  path: '/dashboard/',
  getParentRoute: () => rootRouteImport,
} as any)
const AssignmentsIndexRoute = AssignmentsIndexRouteImport.update({
  id: '/assignments/',
  path: '/assignments/',
  getParentRoute: () => rootRouteImport,
} as any)
const SoutienPanneauRoute = SoutienPanneauRouteImport.update({
  id: '/soutien/panneau',
  path: '/soutien/panneau',
  getParentRoute: () => rootRouteImport,
} as any)
const JudicialRecordIdRoute = JudicialRecordIdRouteImport.update({
  id: '/$recordId',
  path: '/$recordId',
  getParentRoute: () => JudicialRoute,
} as any)
const DashboardRegionIdRoute = DashboardRegionIdRouteImport.update({
  id: '/dashboard/$regionId',
  path: '/dashboard/$regionId',
  getParentRoute: () => rootRouteImport,
} as any)
const AssignmentsAssignmentIdRoute = AssignmentsAssignmentIdRouteImport.update({
  id: '/assignments/$assignmentId',
  path: '/assignments/$assignmentId',
  getParentRoute: () => rootRouteImport,
} as any)
const PromotionsInitiativeIdIndexRoute =
  PromotionsInitiativeIdIndexRouteImport.update({
    id: '/promotions/$initiativeId/',
    path: '/promotions/$initiativeId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const JudicialRecordIdIndexRoute = JudicialRecordIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => JudicialRecordIdRoute,
} as any)
const DashboardRegionIdIndexRoute = DashboardRegionIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRegionIdRoute,
} as any)
const PromotionsInitiativeIdPlacementsRoute =
  PromotionsInitiativeIdPlacementsRouteImport.update({
    id: '/promotions/$initiativeId/placements',
    path: '/promotions/$initiativeId/placements',
    getParentRoute: () => rootRouteImport,
  } as any)
const PromotionsInitiativeIdNationalRoute =
  PromotionsInitiativeIdNationalRouteImport.update({
    id: '/promotions/$initiativeId/national',
    path: '/promotions/$initiativeId/national',
    getParentRoute: () => rootRouteImport,
  } as any)
const PromotionsInitiativeIdRegionIdRoute =
  PromotionsInitiativeIdRegionIdRouteImport.update({
    id: '/promotions/$initiativeId/$regionId',
    path: '/promotions/$initiativeId/$regionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const RegionsMessagesEveningIdIndexRoute =
  RegionsMessagesEveningIdIndexRouteImport.update({
    id: '/regions/messages/$eveningId/',
    path: '/regions/messages/$eveningId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const PromotionsInitiativeIdNationalIndexRoute =
  PromotionsInitiativeIdNationalIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PromotionsInitiativeIdNationalRoute,
  } as any)
const PromotionsInitiativeIdRegionIdIndexRoute =
  PromotionsInitiativeIdRegionIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PromotionsInitiativeIdRegionIdRoute,
  } as any)
const DashboardRegionIdMessagesIndexRoute =
  DashboardRegionIdMessagesIndexRouteImport.update({
    id: '/messages/',
    path: '/messages/',
    getParentRoute: () => DashboardRegionIdRoute,
  } as any)
const RegionsMessagesEveningIdTeamIdRoute =
  RegionsMessagesEveningIdTeamIdRouteImport.update({
    id: '/regions/messages/$eveningId/$teamId',
    path: '/regions/messages/$eveningId/$teamId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PromotionsInitiativeIdNationalPromotionIdRoute =
  PromotionsInitiativeIdNationalPromotionIdRouteImport.update({
    id: '/$promotionId',
    path: '/$promotionId',
    getParentRoute: () => PromotionsInitiativeIdNationalRoute,
  } as any)
const PromotionsInitiativeIdRegionIdCreateRoute =
  PromotionsInitiativeIdRegionIdCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => PromotionsInitiativeIdRegionIdRoute,
  } as any)
const PromotionsInitiativeIdRegionIdBoutiqueRoute =
  PromotionsInitiativeIdRegionIdBoutiqueRouteImport.update({
    id: '/boutique',
    path: '/boutique',
    getParentRoute: () => PromotionsInitiativeIdRegionIdRoute,
  } as any)
const PromotionsInitiativeIdRegionIdPromotionIdRoute =
  PromotionsInitiativeIdRegionIdPromotionIdRouteImport.update({
    id: '/$promotionId',
    path: '/$promotionId',
    getParentRoute: () => PromotionsInitiativeIdRegionIdRoute,
  } as any)
const JudicialRecordIdProvincialSoquijIdRoute =
  JudicialRecordIdProvincialSoquijIdRouteImport.update({
    id: '/provincial/$soquijId',
    path: '/provincial/$soquijId',
    getParentRoute: () => JudicialRecordIdRoute,
  } as any)
const JudicialRecordIdMunicipalSoquijIdRoute =
  JudicialRecordIdMunicipalSoquijIdRouteImport.update({
    id: '/municipal/$soquijId',
    path: '/municipal/$soquijId',
    getParentRoute: () => JudicialRecordIdRoute,
  } as any)
const DashboardRegionIdMessagesNoneRoute =
  DashboardRegionIdMessagesNoneRouteImport.update({
    id: '/messages/none',
    path: '/messages/none',
    getParentRoute: () => DashboardRegionIdRoute,
  } as any)
const DashboardRegionIdMessagesTeamIdRoute =
  DashboardRegionIdMessagesTeamIdRouteImport.update({
    id: '/messages/$teamId',
    path: '/messages/$teamId',
    getParentRoute: () => DashboardRegionIdRoute,
  } as any)
const PromotionsInitiativeIdNationalCreateIndexRoute =
  PromotionsInitiativeIdNationalCreateIndexRouteImport.update({
    id: '/create/',
    path: '/create/',
    getParentRoute: () => PromotionsInitiativeIdNationalRoute,
  } as any)
const RegionsMessagesEveningIdChannelsChannelIdRoute =
  RegionsMessagesEveningIdChannelsChannelIdRouteImport.update({
    id: '/regions/messages/$eveningId/channels/$channelId',
    path: '/regions/messages/$eveningId/channels/$channelId',
    getParentRoute: () => rootRouteImport,
  } as any)
const PromotionsInitiativeIdNationalCreateTypeRoute =
  PromotionsInitiativeIdNationalCreateTypeRouteImport.update({
    id: '/create/$type',
    path: '/create/$type',
    getParentRoute: () => PromotionsInitiativeIdNationalRoute,
  } as any)
const DashboardRegionIdMessagesChannelsChannelIdRoute =
  DashboardRegionIdMessagesChannelsChannelIdRouteImport.update({
    id: '/messages/channels/$channelId',
    path: '/messages/channels/$channelId',
    getParentRoute: () => DashboardRegionIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/judicial': typeof JudicialRouteWithChildren
  '/assignments/$assignmentId': typeof AssignmentsAssignmentIdRoute
  '/dashboard/$regionId': typeof DashboardRegionIdRouteWithChildren
  '/judicial/$recordId': typeof JudicialRecordIdRouteWithChildren
  '/soutien/panneau': typeof SoutienPanneauRoute
  '/assignments': typeof AssignmentsIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/judicial/': typeof JudicialIndexRoute
  '/promotions': typeof PromotionsIndexRoute
  '/regions': typeof RegionsIndexRoute
  '/soutien': typeof SoutienIndexRoute
  '/stats': typeof StatsIndexRoute
  '/promotions/$initiativeId/$regionId': typeof PromotionsInitiativeIdRegionIdRouteWithChildren
  '/promotions/$initiativeId/national': typeof PromotionsInitiativeIdNationalRouteWithChildren
  '/promotions/$initiativeId/placements': typeof PromotionsInitiativeIdPlacementsRoute
  '/dashboard/$regionId/': typeof DashboardRegionIdIndexRoute
  '/judicial/$recordId/': typeof JudicialRecordIdIndexRoute
  '/promotions/$initiativeId': typeof PromotionsInitiativeIdIndexRoute
  '/dashboard/$regionId/messages/$teamId': typeof DashboardRegionIdMessagesTeamIdRoute
  '/dashboard/$regionId/messages/none': typeof DashboardRegionIdMessagesNoneRoute
  '/judicial/$recordId/municipal/$soquijId': typeof JudicialRecordIdMunicipalSoquijIdRoute
  '/judicial/$recordId/provincial/$soquijId': typeof JudicialRecordIdProvincialSoquijIdRoute
  '/promotions/$initiativeId/$regionId/$promotionId': typeof PromotionsInitiativeIdRegionIdPromotionIdRoute
  '/promotions/$initiativeId/$regionId/boutique': typeof PromotionsInitiativeIdRegionIdBoutiqueRoute
  '/promotions/$initiativeId/$regionId/create': typeof PromotionsInitiativeIdRegionIdCreateRoute
  '/promotions/$initiativeId/national/$promotionId': typeof PromotionsInitiativeIdNationalPromotionIdRoute
  '/regions/messages/$eveningId/$teamId': typeof RegionsMessagesEveningIdTeamIdRoute
  '/dashboard/$regionId/messages': typeof DashboardRegionIdMessagesIndexRoute
  '/promotions/$initiativeId/$regionId/': typeof PromotionsInitiativeIdRegionIdIndexRoute
  '/promotions/$initiativeId/national/': typeof PromotionsInitiativeIdNationalIndexRoute
  '/regions/messages/$eveningId': typeof RegionsMessagesEveningIdIndexRoute
  '/dashboard/$regionId/messages/channels/$channelId': typeof DashboardRegionIdMessagesChannelsChannelIdRoute
  '/promotions/$initiativeId/national/create/$type': typeof PromotionsInitiativeIdNationalCreateTypeRoute
  '/regions/messages/$eveningId/channels/$channelId': typeof RegionsMessagesEveningIdChannelsChannelIdRoute
  '/promotions/$initiativeId/national/create': typeof PromotionsInitiativeIdNationalCreateIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/assignments/$assignmentId': typeof AssignmentsAssignmentIdRoute
  '/soutien/panneau': typeof SoutienPanneauRoute
  '/assignments': typeof AssignmentsIndexRoute
  '/dashboard': typeof DashboardIndexRoute
  '/judicial': typeof JudicialIndexRoute
  '/promotions': typeof PromotionsIndexRoute
  '/regions': typeof RegionsIndexRoute
  '/soutien': typeof SoutienIndexRoute
  '/stats': typeof StatsIndexRoute
  '/promotions/$initiativeId/placements': typeof PromotionsInitiativeIdPlacementsRoute
  '/dashboard/$regionId': typeof DashboardRegionIdIndexRoute
  '/judicial/$recordId': typeof JudicialRecordIdIndexRoute
  '/promotions/$initiativeId': typeof PromotionsInitiativeIdIndexRoute
  '/dashboard/$regionId/messages/$teamId': typeof DashboardRegionIdMessagesTeamIdRoute
  '/dashboard/$regionId/messages/none': typeof DashboardRegionIdMessagesNoneRoute
  '/judicial/$recordId/municipal/$soquijId': typeof JudicialRecordIdMunicipalSoquijIdRoute
  '/judicial/$recordId/provincial/$soquijId': typeof JudicialRecordIdProvincialSoquijIdRoute
  '/promotions/$initiativeId/$regionId/$promotionId': typeof PromotionsInitiativeIdRegionIdPromotionIdRoute
  '/promotions/$initiativeId/$regionId/boutique': typeof PromotionsInitiativeIdRegionIdBoutiqueRoute
  '/promotions/$initiativeId/$regionId/create': typeof PromotionsInitiativeIdRegionIdCreateRoute
  '/promotions/$initiativeId/national/$promotionId': typeof PromotionsInitiativeIdNationalPromotionIdRoute
  '/regions/messages/$eveningId/$teamId': typeof RegionsMessagesEveningIdTeamIdRoute
  '/dashboard/$regionId/messages': typeof DashboardRegionIdMessagesIndexRoute
  '/promotions/$initiativeId/$regionId': typeof PromotionsInitiativeIdRegionIdIndexRoute
  '/promotions/$initiativeId/national': typeof PromotionsInitiativeIdNationalIndexRoute
  '/regions/messages/$eveningId': typeof RegionsMessagesEveningIdIndexRoute
  '/dashboard/$regionId/messages/channels/$channelId': typeof DashboardRegionIdMessagesChannelsChannelIdRoute
  '/promotions/$initiativeId/national/create/$type': typeof PromotionsInitiativeIdNationalCreateTypeRoute
  '/regions/messages/$eveningId/channels/$channelId': typeof RegionsMessagesEveningIdChannelsChannelIdRoute
  '/promotions/$initiativeId/national/create': typeof PromotionsInitiativeIdNationalCreateIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/judicial': typeof JudicialRouteWithChildren
  '/assignments/$assignmentId': typeof AssignmentsAssignmentIdRoute
  '/dashboard/$regionId': typeof DashboardRegionIdRouteWithChildren
  '/judicial/$recordId': typeof JudicialRecordIdRouteWithChildren
  '/soutien/panneau': typeof SoutienPanneauRoute
  '/assignments/': typeof AssignmentsIndexRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/judicial/': typeof JudicialIndexRoute
  '/promotions/': typeof PromotionsIndexRoute
  '/regions/': typeof RegionsIndexRoute
  '/soutien/': typeof SoutienIndexRoute
  '/stats/': typeof StatsIndexRoute
  '/promotions/$initiativeId/$regionId': typeof PromotionsInitiativeIdRegionIdRouteWithChildren
  '/promotions/$initiativeId/national': typeof PromotionsInitiativeIdNationalRouteWithChildren
  '/promotions/$initiativeId/placements': typeof PromotionsInitiativeIdPlacementsRoute
  '/dashboard/$regionId/': typeof DashboardRegionIdIndexRoute
  '/judicial/$recordId/': typeof JudicialRecordIdIndexRoute
  '/promotions/$initiativeId/': typeof PromotionsInitiativeIdIndexRoute
  '/dashboard/$regionId/messages/$teamId': typeof DashboardRegionIdMessagesTeamIdRoute
  '/dashboard/$regionId/messages/none': typeof DashboardRegionIdMessagesNoneRoute
  '/judicial/$recordId/municipal/$soquijId': typeof JudicialRecordIdMunicipalSoquijIdRoute
  '/judicial/$recordId/provincial/$soquijId': typeof JudicialRecordIdProvincialSoquijIdRoute
  '/promotions/$initiativeId/$regionId/$promotionId': typeof PromotionsInitiativeIdRegionIdPromotionIdRoute
  '/promotions/$initiativeId/$regionId/boutique': typeof PromotionsInitiativeIdRegionIdBoutiqueRoute
  '/promotions/$initiativeId/$regionId/create': typeof PromotionsInitiativeIdRegionIdCreateRoute
  '/promotions/$initiativeId/national/$promotionId': typeof PromotionsInitiativeIdNationalPromotionIdRoute
  '/regions/messages/$eveningId/$teamId': typeof RegionsMessagesEveningIdTeamIdRoute
  '/dashboard/$regionId/messages/': typeof DashboardRegionIdMessagesIndexRoute
  '/promotions/$initiativeId/$regionId/': typeof PromotionsInitiativeIdRegionIdIndexRoute
  '/promotions/$initiativeId/national/': typeof PromotionsInitiativeIdNationalIndexRoute
  '/regions/messages/$eveningId/': typeof RegionsMessagesEveningIdIndexRoute
  '/dashboard/$regionId/messages/channels/$channelId': typeof DashboardRegionIdMessagesChannelsChannelIdRoute
  '/promotions/$initiativeId/national/create/$type': typeof PromotionsInitiativeIdNationalCreateTypeRoute
  '/regions/messages/$eveningId/channels/$channelId': typeof RegionsMessagesEveningIdChannelsChannelIdRoute
  '/promotions/$initiativeId/national/create/': typeof PromotionsInitiativeIdNationalCreateIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/judicial'
    | '/assignments/$assignmentId'
    | '/dashboard/$regionId'
    | '/judicial/$recordId'
    | '/soutien/panneau'
    | '/assignments'
    | '/dashboard'
    | '/judicial/'
    | '/promotions'
    | '/regions'
    | '/soutien'
    | '/stats'
    | '/promotions/$initiativeId/$regionId'
    | '/promotions/$initiativeId/national'
    | '/promotions/$initiativeId/placements'
    | '/dashboard/$regionId/'
    | '/judicial/$recordId/'
    | '/promotions/$initiativeId'
    | '/dashboard/$regionId/messages/$teamId'
    | '/dashboard/$regionId/messages/none'
    | '/judicial/$recordId/municipal/$soquijId'
    | '/judicial/$recordId/provincial/$soquijId'
    | '/promotions/$initiativeId/$regionId/$promotionId'
    | '/promotions/$initiativeId/$regionId/boutique'
    | '/promotions/$initiativeId/$regionId/create'
    | '/promotions/$initiativeId/national/$promotionId'
    | '/regions/messages/$eveningId/$teamId'
    | '/dashboard/$regionId/messages'
    | '/promotions/$initiativeId/$regionId/'
    | '/promotions/$initiativeId/national/'
    | '/regions/messages/$eveningId'
    | '/dashboard/$regionId/messages/channels/$channelId'
    | '/promotions/$initiativeId/national/create/$type'
    | '/regions/messages/$eveningId/channels/$channelId'
    | '/promotions/$initiativeId/national/create'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/assignments/$assignmentId'
    | '/soutien/panneau'
    | '/assignments'
    | '/dashboard'
    | '/judicial'
    | '/promotions'
    | '/regions'
    | '/soutien'
    | '/stats'
    | '/promotions/$initiativeId/placements'
    | '/dashboard/$regionId'
    | '/judicial/$recordId'
    | '/promotions/$initiativeId'
    | '/dashboard/$regionId/messages/$teamId'
    | '/dashboard/$regionId/messages/none'
    | '/judicial/$recordId/municipal/$soquijId'
    | '/judicial/$recordId/provincial/$soquijId'
    | '/promotions/$initiativeId/$regionId/$promotionId'
    | '/promotions/$initiativeId/$regionId/boutique'
    | '/promotions/$initiativeId/$regionId/create'
    | '/promotions/$initiativeId/national/$promotionId'
    | '/regions/messages/$eveningId/$teamId'
    | '/dashboard/$regionId/messages'
    | '/promotions/$initiativeId/$regionId'
    | '/promotions/$initiativeId/national'
    | '/regions/messages/$eveningId'
    | '/dashboard/$regionId/messages/channels/$channelId'
    | '/promotions/$initiativeId/national/create/$type'
    | '/regions/messages/$eveningId/channels/$channelId'
    | '/promotions/$initiativeId/national/create'
  id:
    | '__root__'
    | '/'
    | '/judicial'
    | '/assignments/$assignmentId'
    | '/dashboard/$regionId'
    | '/judicial/$recordId'
    | '/soutien/panneau'
    | '/assignments/'
    | '/dashboard/'
    | '/judicial/'
    | '/promotions/'
    | '/regions/'
    | '/soutien/'
    | '/stats/'
    | '/promotions/$initiativeId/$regionId'
    | '/promotions/$initiativeId/national'
    | '/promotions/$initiativeId/placements'
    | '/dashboard/$regionId/'
    | '/judicial/$recordId/'
    | '/promotions/$initiativeId/'
    | '/dashboard/$regionId/messages/$teamId'
    | '/dashboard/$regionId/messages/none'
    | '/judicial/$recordId/municipal/$soquijId'
    | '/judicial/$recordId/provincial/$soquijId'
    | '/promotions/$initiativeId/$regionId/$promotionId'
    | '/promotions/$initiativeId/$regionId/boutique'
    | '/promotions/$initiativeId/$regionId/create'
    | '/promotions/$initiativeId/national/$promotionId'
    | '/regions/messages/$eveningId/$teamId'
    | '/dashboard/$regionId/messages/'
    | '/promotions/$initiativeId/$regionId/'
    | '/promotions/$initiativeId/national/'
    | '/regions/messages/$eveningId/'
    | '/dashboard/$regionId/messages/channels/$channelId'
    | '/promotions/$initiativeId/national/create/$type'
    | '/regions/messages/$eveningId/channels/$channelId'
    | '/promotions/$initiativeId/national/create/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  JudicialRoute: typeof JudicialRouteWithChildren
  AssignmentsAssignmentIdRoute: typeof AssignmentsAssignmentIdRoute
  DashboardRegionIdRoute: typeof DashboardRegionIdRouteWithChildren
  SoutienPanneauRoute: typeof SoutienPanneauRoute
  AssignmentsIndexRoute: typeof AssignmentsIndexRoute
  DashboardIndexRoute: typeof DashboardIndexRoute
  PromotionsIndexRoute: typeof PromotionsIndexRoute
  RegionsIndexRoute: typeof RegionsIndexRoute
  SoutienIndexRoute: typeof SoutienIndexRoute
  StatsIndexRoute: typeof StatsIndexRoute
  PromotionsInitiativeIdRegionIdRoute: typeof PromotionsInitiativeIdRegionIdRouteWithChildren
  PromotionsInitiativeIdNationalRoute: typeof PromotionsInitiativeIdNationalRouteWithChildren
  PromotionsInitiativeIdPlacementsRoute: typeof PromotionsInitiativeIdPlacementsRoute
  PromotionsInitiativeIdIndexRoute: typeof PromotionsInitiativeIdIndexRoute
  RegionsMessagesEveningIdTeamIdRoute: typeof RegionsMessagesEveningIdTeamIdRoute
  RegionsMessagesEveningIdIndexRoute: typeof RegionsMessagesEveningIdIndexRoute
  RegionsMessagesEveningIdChannelsChannelIdRoute: typeof RegionsMessagesEveningIdChannelsChannelIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/judicial': {
      id: '/judicial'
      path: '/judicial'
      fullPath: '/judicial'
      preLoaderRoute: typeof JudicialRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stats/': {
      id: '/stats/'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof StatsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/soutien/': {
      id: '/soutien/'
      path: '/soutien'
      fullPath: '/soutien'
      preLoaderRoute: typeof SoutienIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/regions/': {
      id: '/regions/'
      path: '/regions'
      fullPath: '/regions'
      preLoaderRoute: typeof RegionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/promotions/': {
      id: '/promotions/'
      path: '/promotions'
      fullPath: '/promotions'
      preLoaderRoute: typeof PromotionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/judicial/': {
      id: '/judicial/'
      path: '/'
      fullPath: '/judicial/'
      preLoaderRoute: typeof JudicialIndexRouteImport
      parentRoute: typeof JudicialRoute
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assignments/': {
      id: '/assignments/'
      path: '/assignments'
      fullPath: '/assignments'
      preLoaderRoute: typeof AssignmentsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/soutien/panneau': {
      id: '/soutien/panneau'
      path: '/soutien/panneau'
      fullPath: '/soutien/panneau'
      preLoaderRoute: typeof SoutienPanneauRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/judicial/$recordId': {
      id: '/judicial/$recordId'
      path: '/$recordId'
      fullPath: '/judicial/$recordId'
      preLoaderRoute: typeof JudicialRecordIdRouteImport
      parentRoute: typeof JudicialRoute
    }
    '/dashboard/$regionId': {
      id: '/dashboard/$regionId'
      path: '/dashboard/$regionId'
      fullPath: '/dashboard/$regionId'
      preLoaderRoute: typeof DashboardRegionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/assignments/$assignmentId': {
      id: '/assignments/$assignmentId'
      path: '/assignments/$assignmentId'
      fullPath: '/assignments/$assignmentId'
      preLoaderRoute: typeof AssignmentsAssignmentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/promotions/$initiativeId/': {
      id: '/promotions/$initiativeId/'
      path: '/promotions/$initiativeId'
      fullPath: '/promotions/$initiativeId'
      preLoaderRoute: typeof PromotionsInitiativeIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/judicial/$recordId/': {
      id: '/judicial/$recordId/'
      path: '/'
      fullPath: '/judicial/$recordId/'
      preLoaderRoute: typeof JudicialRecordIdIndexRouteImport
      parentRoute: typeof JudicialRecordIdRoute
    }
    '/dashboard/$regionId/': {
      id: '/dashboard/$regionId/'
      path: '/'
      fullPath: '/dashboard/$regionId/'
      preLoaderRoute: typeof DashboardRegionIdIndexRouteImport
      parentRoute: typeof DashboardRegionIdRoute
    }
    '/promotions/$initiativeId/placements': {
      id: '/promotions/$initiativeId/placements'
      path: '/promotions/$initiativeId/placements'
      fullPath: '/promotions/$initiativeId/placements'
      preLoaderRoute: typeof PromotionsInitiativeIdPlacementsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/promotions/$initiativeId/national': {
      id: '/promotions/$initiativeId/national'
      path: '/promotions/$initiativeId/national'
      fullPath: '/promotions/$initiativeId/national'
      preLoaderRoute: typeof PromotionsInitiativeIdNationalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/promotions/$initiativeId/$regionId': {
      id: '/promotions/$initiativeId/$regionId'
      path: '/promotions/$initiativeId/$regionId'
      fullPath: '/promotions/$initiativeId/$regionId'
      preLoaderRoute: typeof PromotionsInitiativeIdRegionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/regions/messages/$eveningId/': {
      id: '/regions/messages/$eveningId/'
      path: '/regions/messages/$eveningId'
      fullPath: '/regions/messages/$eveningId'
      preLoaderRoute: typeof RegionsMessagesEveningIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/promotions/$initiativeId/national/': {
      id: '/promotions/$initiativeId/national/'
      path: '/'
      fullPath: '/promotions/$initiativeId/national/'
      preLoaderRoute: typeof PromotionsInitiativeIdNationalIndexRouteImport
      parentRoute: typeof PromotionsInitiativeIdNationalRoute
    }
    '/promotions/$initiativeId/$regionId/': {
      id: '/promotions/$initiativeId/$regionId/'
      path: '/'
      fullPath: '/promotions/$initiativeId/$regionId/'
      preLoaderRoute: typeof PromotionsInitiativeIdRegionIdIndexRouteImport
      parentRoute: typeof PromotionsInitiativeIdRegionIdRoute
    }
    '/dashboard/$regionId/messages/': {
      id: '/dashboard/$regionId/messages/'
      path: '/messages'
      fullPath: '/dashboard/$regionId/messages'
      preLoaderRoute: typeof DashboardRegionIdMessagesIndexRouteImport
      parentRoute: typeof DashboardRegionIdRoute
    }
    '/regions/messages/$eveningId/$teamId': {
      id: '/regions/messages/$eveningId/$teamId'
      path: '/regions/messages/$eveningId/$teamId'
      fullPath: '/regions/messages/$eveningId/$teamId'
      preLoaderRoute: typeof RegionsMessagesEveningIdTeamIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/promotions/$initiativeId/national/$promotionId': {
      id: '/promotions/$initiativeId/national/$promotionId'
      path: '/$promotionId'
      fullPath: '/promotions/$initiativeId/national/$promotionId'
      preLoaderRoute: typeof PromotionsInitiativeIdNationalPromotionIdRouteImport
      parentRoute: typeof PromotionsInitiativeIdNationalRoute
    }
    '/promotions/$initiativeId/$regionId/create': {
      id: '/promotions/$initiativeId/$regionId/create'
      path: '/create'
      fullPath: '/promotions/$initiativeId/$regionId/create'
      preLoaderRoute: typeof PromotionsInitiativeIdRegionIdCreateRouteImport
      parentRoute: typeof PromotionsInitiativeIdRegionIdRoute
    }
    '/promotions/$initiativeId/$regionId/boutique': {
      id: '/promotions/$initiativeId/$regionId/boutique'
      path: '/boutique'
      fullPath: '/promotions/$initiativeId/$regionId/boutique'
      preLoaderRoute: typeof PromotionsInitiativeIdRegionIdBoutiqueRouteImport
      parentRoute: typeof PromotionsInitiativeIdRegionIdRoute
    }
    '/promotions/$initiativeId/$regionId/$promotionId': {
      id: '/promotions/$initiativeId/$regionId/$promotionId'
      path: '/$promotionId'
      fullPath: '/promotions/$initiativeId/$regionId/$promotionId'
      preLoaderRoute: typeof PromotionsInitiativeIdRegionIdPromotionIdRouteImport
      parentRoute: typeof PromotionsInitiativeIdRegionIdRoute
    }
    '/judicial/$recordId/provincial/$soquijId': {
      id: '/judicial/$recordId/provincial/$soquijId'
      path: '/provincial/$soquijId'
      fullPath: '/judicial/$recordId/provincial/$soquijId'
      preLoaderRoute: typeof JudicialRecordIdProvincialSoquijIdRouteImport
      parentRoute: typeof JudicialRecordIdRoute
    }
    '/judicial/$recordId/municipal/$soquijId': {
      id: '/judicial/$recordId/municipal/$soquijId'
      path: '/municipal/$soquijId'
      fullPath: '/judicial/$recordId/municipal/$soquijId'
      preLoaderRoute: typeof JudicialRecordIdMunicipalSoquijIdRouteImport
      parentRoute: typeof JudicialRecordIdRoute
    }
    '/dashboard/$regionId/messages/none': {
      id: '/dashboard/$regionId/messages/none'
      path: '/messages/none'
      fullPath: '/dashboard/$regionId/messages/none'
      preLoaderRoute: typeof DashboardRegionIdMessagesNoneRouteImport
      parentRoute: typeof DashboardRegionIdRoute
    }
    '/dashboard/$regionId/messages/$teamId': {
      id: '/dashboard/$regionId/messages/$teamId'
      path: '/messages/$teamId'
      fullPath: '/dashboard/$regionId/messages/$teamId'
      preLoaderRoute: typeof DashboardRegionIdMessagesTeamIdRouteImport
      parentRoute: typeof DashboardRegionIdRoute
    }
    '/promotions/$initiativeId/national/create/': {
      id: '/promotions/$initiativeId/national/create/'
      path: '/create'
      fullPath: '/promotions/$initiativeId/national/create'
      preLoaderRoute: typeof PromotionsInitiativeIdNationalCreateIndexRouteImport
      parentRoute: typeof PromotionsInitiativeIdNationalRoute
    }
    '/regions/messages/$eveningId/channels/$channelId': {
      id: '/regions/messages/$eveningId/channels/$channelId'
      path: '/regions/messages/$eveningId/channels/$channelId'
      fullPath: '/regions/messages/$eveningId/channels/$channelId'
      preLoaderRoute: typeof RegionsMessagesEveningIdChannelsChannelIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/promotions/$initiativeId/national/create/$type': {
      id: '/promotions/$initiativeId/national/create/$type'
      path: '/create/$type'
      fullPath: '/promotions/$initiativeId/national/create/$type'
      preLoaderRoute: typeof PromotionsInitiativeIdNationalCreateTypeRouteImport
      parentRoute: typeof PromotionsInitiativeIdNationalRoute
    }
    '/dashboard/$regionId/messages/channels/$channelId': {
      id: '/dashboard/$regionId/messages/channels/$channelId'
      path: '/messages/channels/$channelId'
      fullPath: '/dashboard/$regionId/messages/channels/$channelId'
      preLoaderRoute: typeof DashboardRegionIdMessagesChannelsChannelIdRouteImport
      parentRoute: typeof DashboardRegionIdRoute
    }
  }
}

interface JudicialRecordIdRouteChildren {
  JudicialRecordIdIndexRoute: typeof JudicialRecordIdIndexRoute
  JudicialRecordIdMunicipalSoquijIdRoute: typeof JudicialRecordIdMunicipalSoquijIdRoute
  JudicialRecordIdProvincialSoquijIdRoute: typeof JudicialRecordIdProvincialSoquijIdRoute
}

const JudicialRecordIdRouteChildren: JudicialRecordIdRouteChildren = {
  JudicialRecordIdIndexRoute: JudicialRecordIdIndexRoute,
  JudicialRecordIdMunicipalSoquijIdRoute:
    JudicialRecordIdMunicipalSoquijIdRoute,
  JudicialRecordIdProvincialSoquijIdRoute:
    JudicialRecordIdProvincialSoquijIdRoute,
}

const JudicialRecordIdRouteWithChildren =
  JudicialRecordIdRoute._addFileChildren(JudicialRecordIdRouteChildren)

interface JudicialRouteChildren {
  JudicialRecordIdRoute: typeof JudicialRecordIdRouteWithChildren
  JudicialIndexRoute: typeof JudicialIndexRoute
}

const JudicialRouteChildren: JudicialRouteChildren = {
  JudicialRecordIdRoute: JudicialRecordIdRouteWithChildren,
  JudicialIndexRoute: JudicialIndexRoute,
}

const JudicialRouteWithChildren = JudicialRoute._addFileChildren(
  JudicialRouteChildren,
)

interface DashboardRegionIdRouteChildren {
  DashboardRegionIdIndexRoute: typeof DashboardRegionIdIndexRoute
  DashboardRegionIdMessagesTeamIdRoute: typeof DashboardRegionIdMessagesTeamIdRoute
  DashboardRegionIdMessagesNoneRoute: typeof DashboardRegionIdMessagesNoneRoute
  DashboardRegionIdMessagesIndexRoute: typeof DashboardRegionIdMessagesIndexRoute
  DashboardRegionIdMessagesChannelsChannelIdRoute: typeof DashboardRegionIdMessagesChannelsChannelIdRoute
}

const DashboardRegionIdRouteChildren: DashboardRegionIdRouteChildren = {
  DashboardRegionIdIndexRoute: DashboardRegionIdIndexRoute,
  DashboardRegionIdMessagesTeamIdRoute: DashboardRegionIdMessagesTeamIdRoute,
  DashboardRegionIdMessagesNoneRoute: DashboardRegionIdMessagesNoneRoute,
  DashboardRegionIdMessagesIndexRoute: DashboardRegionIdMessagesIndexRoute,
  DashboardRegionIdMessagesChannelsChannelIdRoute:
    DashboardRegionIdMessagesChannelsChannelIdRoute,
}

const DashboardRegionIdRouteWithChildren =
  DashboardRegionIdRoute._addFileChildren(DashboardRegionIdRouteChildren)

interface PromotionsInitiativeIdRegionIdRouteChildren {
  PromotionsInitiativeIdRegionIdPromotionIdRoute: typeof PromotionsInitiativeIdRegionIdPromotionIdRoute
  PromotionsInitiativeIdRegionIdBoutiqueRoute: typeof PromotionsInitiativeIdRegionIdBoutiqueRoute
  PromotionsInitiativeIdRegionIdCreateRoute: typeof PromotionsInitiativeIdRegionIdCreateRoute
  PromotionsInitiativeIdRegionIdIndexRoute: typeof PromotionsInitiativeIdRegionIdIndexRoute
}

const PromotionsInitiativeIdRegionIdRouteChildren: PromotionsInitiativeIdRegionIdRouteChildren =
  {
    PromotionsInitiativeIdRegionIdPromotionIdRoute:
      PromotionsInitiativeIdRegionIdPromotionIdRoute,
    PromotionsInitiativeIdRegionIdBoutiqueRoute:
      PromotionsInitiativeIdRegionIdBoutiqueRoute,
    PromotionsInitiativeIdRegionIdCreateRoute:
      PromotionsInitiativeIdRegionIdCreateRoute,
    PromotionsInitiativeIdRegionIdIndexRoute:
      PromotionsInitiativeIdRegionIdIndexRoute,
  }

const PromotionsInitiativeIdRegionIdRouteWithChildren =
  PromotionsInitiativeIdRegionIdRoute._addFileChildren(
    PromotionsInitiativeIdRegionIdRouteChildren,
  )

interface PromotionsInitiativeIdNationalRouteChildren {
  PromotionsInitiativeIdNationalPromotionIdRoute: typeof PromotionsInitiativeIdNationalPromotionIdRoute
  PromotionsInitiativeIdNationalIndexRoute: typeof PromotionsInitiativeIdNationalIndexRoute
  PromotionsInitiativeIdNationalCreateTypeRoute: typeof PromotionsInitiativeIdNationalCreateTypeRoute
  PromotionsInitiativeIdNationalCreateIndexRoute: typeof PromotionsInitiativeIdNationalCreateIndexRoute
}

const PromotionsInitiativeIdNationalRouteChildren: PromotionsInitiativeIdNationalRouteChildren =
  {
    PromotionsInitiativeIdNationalPromotionIdRoute:
      PromotionsInitiativeIdNationalPromotionIdRoute,
    PromotionsInitiativeIdNationalIndexRoute:
      PromotionsInitiativeIdNationalIndexRoute,
    PromotionsInitiativeIdNationalCreateTypeRoute:
      PromotionsInitiativeIdNationalCreateTypeRoute,
    PromotionsInitiativeIdNationalCreateIndexRoute:
      PromotionsInitiativeIdNationalCreateIndexRoute,
  }

const PromotionsInitiativeIdNationalRouteWithChildren =
  PromotionsInitiativeIdNationalRoute._addFileChildren(
    PromotionsInitiativeIdNationalRouteChildren,
  )

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  JudicialRoute: JudicialRouteWithChildren,
  AssignmentsAssignmentIdRoute: AssignmentsAssignmentIdRoute,
  DashboardRegionIdRoute: DashboardRegionIdRouteWithChildren,
  SoutienPanneauRoute: SoutienPanneauRoute,
  AssignmentsIndexRoute: AssignmentsIndexRoute,
  DashboardIndexRoute: DashboardIndexRoute,
  PromotionsIndexRoute: PromotionsIndexRoute,
  RegionsIndexRoute: RegionsIndexRoute,
  SoutienIndexRoute: SoutienIndexRoute,
  StatsIndexRoute: StatsIndexRoute,
  PromotionsInitiativeIdRegionIdRoute:
    PromotionsInitiativeIdRegionIdRouteWithChildren,
  PromotionsInitiativeIdNationalRoute:
    PromotionsInitiativeIdNationalRouteWithChildren,
  PromotionsInitiativeIdPlacementsRoute: PromotionsInitiativeIdPlacementsRoute,
  PromotionsInitiativeIdIndexRoute: PromotionsInitiativeIdIndexRoute,
  RegionsMessagesEveningIdTeamIdRoute: RegionsMessagesEveningIdTeamIdRoute,
  RegionsMessagesEveningIdIndexRoute: RegionsMessagesEveningIdIndexRoute,
  RegionsMessagesEveningIdChannelsChannelIdRoute:
    RegionsMessagesEveningIdChannelsChannelIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
